import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Sidebar from "../../../components/Sidebar";
import AppConstants from "../../../utils/appConstants";
import { useToast } from "../../../contexts/ToastContext";
import {
  fetchEmailNotificationSetting,
  saveEmailNotificationSetting,
} from "../../../controller/settingsController/securitySettingsController";
import "../../css/settingsExtras.css";

export default function EmailNotification() {
  const { t } = useTranslation("mobile");
  const { success: showSuccess, error: showError } = useToast();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [emailEnabled, setEmailEnabled] = useState(false);

  useEffect(() => {
    try {
      const storedUser = sessionStorage.getItem("userData");
      if (storedUser) setUser(JSON.parse(storedUser));
    } catch (_) {}
  }, []);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const result = await fetchEmailNotificationSetting();
        if (result.code === AppConstants.responseOk) {
          setEmailEnabled(result.emailEnabled);
        } else {
          showError(
            t("error", { ns: "mobile", defaultValue: "Error" }),
            result.message || t("failed_to_load_email_notification_setting", { ns: "mobile", defaultValue: "Failed to load email notification setting." })
          );
        }
      } catch (error) {
        showError(
          t("error", { ns: "mobile", defaultValue: "Error" }),
          error?.message || t("failed_to_load_email_notification_setting", { ns: "mobile", defaultValue: "Failed to load email notification setting." })
        );
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [showError]);

  const handleToggle = async (checked) => {
    setEmailEnabled(checked);
    setSaving(true);
    try {
      const result = await saveEmailNotificationSetting(checked);
      if (result.code === AppConstants.responseOk) {
        showSuccess(
          t("success", { ns: "mobile", defaultValue: "Success" }),
          t("email_notification_setting_updated", { ns: "mobile", defaultValue: "Email notification setting updated." })
        );
      } else {
        setEmailEnabled((prev) => !prev);
        showError(
          t("error", { ns: "mobile", defaultValue: "Error" }),
          result.message || t("failed_to_update_email_notification_setting", { ns: "mobile", defaultValue: "Failed to update email notification setting." })
        );
      }
    } catch (error) {
      setEmailEnabled((prev) => !prev);
      showError(
        t("error", { ns: "mobile", defaultValue: "Error" }),
        error?.message || t("failed_to_update_email_notification_setting", { ns: "mobile", defaultValue: "Failed to update email notification setting." })
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="settings-extra-page">
      <Sidebar user={user} />
      <div className="settings-extra-content">
        <h1 className="settings-extra-title">{t("email_notification", { ns: "mobile", defaultValue: "Email Notification" })}</h1>
        <div className="settings-extra-card">
          {loading ? (
            <div className="settings-extra-loading">{t("loading", { ns: "mobile", defaultValue: "Loading" })}...</div>
          ) : (
            <div className="settings-extra-row">
              <div>
                <div className="settings-extra-row-title">
                  {t("receive_email_notifications", { ns: "mobile", defaultValue: "Receive Email Notifications" })}
                </div>
                <div className="settings-extra-row-subtitle">
                  {t("enable_or_disable_email_updates", {
                    ns: "mobile",
                    defaultValue: "Enable or disable email updates for account activity.",
                  })}
                </div>
              </div>
              <label
                className="settings-extra-switch"
                aria-label={t("email_notifications", { ns: "mobile", defaultValue: "Email notifications" })}
              >
                <input
                  type="checkbox"
                  checked={emailEnabled}
                  onChange={(e) => handleToggle(e.target.checked)}
                  disabled={saving}
                />
                <span className="settings-extra-slider" />
              </label>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
